export const FETCH_PAYROLL_MASTER_DDLS = "FETCH_PAYROLL_MASTER_DDLS";
